
import { PropType, computed, defineComponent } from 'vue';
import { getters as generalGetters } from '@/store/modules/general/getters';
import { useStore } from '@/store';
import { NameResolutionType } from '@/enums/Global';

export default defineComponent({
  name: 'NameResolution',
  props: {
    id: {
      type: String,
      required: true,
    },
    type: {
      type: String as PropType<NameResolutionType>,
      required: true,
    },
    fallbackValue: {
      type: String,
      required: false,
    },
  },
  setup(props) {
    const store = useStore();
    const defaultValue = computed(() =>
      props.fallbackValue ? props.fallbackValue : props.id
    );
    const isLoading = computed(() =>
      generalGetters.getNameResolutionIsLoading(store.state.general, props.type)
    );
    const name = computed(() =>
      generalGetters.getNameFromNameResolutionMap(store.state.general, {
        id: props.id,
        type: props.type,
      })
    );
    return {
      name,
      isLoading,
      defaultValue,
    };
  },
});
